module.exports = __webpack_public_path__ + "media/images/Web_Giveback-0aeb3c1756637622c2a4b7871458decb.png";